<template lang="html">
    <section class="product-detail"  ref="detail">
        <div class="pic-item" v-if="detailData.orderFlow && detailData.orderFlow.orderFlowImageList">
            <div class="pic-item-inner" v-if="detailData.orderFlow && detailData.orderFlow.orderFlowImageList">
                <div  v-if="detailData.orderFlow && detailData.orderFlow.orderFlowImageList" v-for="item in detailData.orderFlow.orderFlowImageList">
                    <div class="pic-item-orderFlow">
                        <img class="pic-item-img" :src="getBase64Url(item.item.split('.')[0])" />
                        <span>{{item.name}}</span>
                    </div>
                    <span class="pic-item-split" v-if="item.order !== detailData.orderFlow.orderFlowImageList.length"></span>
                </div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.recommendReason">
            <div class="info-item-title">
                推荐理由
            </div>
            <div class="info-item-cont" v-html="detailData.recommendReason.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
        </div>
        <div class="info-item" v-if="detailData.productIntroduce && detailData.productIntroduce.productDetails && detailData.productIntroduce.productDetails.length">
            <div class="info-item-title">
                产品介绍
            </div>
            <div v-for="item in detailData.productIntroduce.productDetails">
                <div class="info-item-cont" v-if="item.descInfo" v-html="item.descInfo.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
                <div :class="{'info-item-images': true, 'need-gap': item.gapless === 0}" v-if="item.images && item.images.length">
                    <img v-for="image in item.images" v-lazy="resizeImage(image.imgUrl.replace(/https?:/, ''), 1024, 0, 0)" width="100%" style="display:block;">
                </div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.trafficDescr || (detailData.trafficInfo && detailData.trafficInfo.length)">
            <div class="info-item-title">
                参考交通
            </div>
            <div class="info-item-cont">
                <span class="traffic-descr" v-if="detailData.trafficDescr" v-html="detailData.trafficDescr.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></span>
                <div class="traffic-depart-name" v-if="detailData.trafficInfo && detailData.trafficInfo.length > 1">
                    <span class="item"
                            v-for="(item, index) in detailData.trafficInfo"
                            :class="[{active: index === cIndex},{noType: (index + 1) % 4 === 0 && index !== 0}]"
                            @click="showTraffic(index)"
                            v-if="item.departCityName != ''"
                            v-show="index < showIndex">{{item.departCityName}}</span>

                    <span class="item show-all" @click="showAll(detailData.trafficInfo.length)" v-show="showAllFlag" v-if="detailData.trafficInfo.length > 7">展开</span>
                    <span class="show-no item"  @click="hideAll" v-show="!showAllFlag"  v-if="detailData.trafficInfo.length > 7">收起</span>
                </div>
                <div class="traffic-info" v-if="currentTraffic && currentTraffic.trafficDetails && currentTraffic.trafficDetails.length">
                    <div class="traffic-info-item" v-for="msg in currentTraffic.trafficDetails">
                        <div class="resource-col tsp"><span>{{ msg.journeyType == 1 ? "去":"返"}}</span></div>
                        <div class="resource-col depart"><div class="depart-time">{{msg.departTime || "待定"}}</div><div class="depart-name">{{msg.departCityName}}</div></div>
                        <div class="resource-col middle"><div class="company-name">{{msg.airline}}</div><div class="company-num">{{msg.flightNo}}</div></div>
                        <div class="resource-col arrive"><div class="arrive-time">{{msg.destTime || "待定"}}</div><div class="arrive-name">{{msg.destCityName}}</div></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.hotelDescr || (detailData.hotelInfos && detailData.hotelInfos.length)">
            <div class="info-item-title">
                参考酒店
            </div>
            <div class="info-item-cont">
                <span class="hotel-descr" v-if="detailData.hotelDescr" v-html="detailData.hotelDescr.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></span>
                <div class="hotel-list-item" v-if="detailData.hotelInfos && detailData.hotelInfos.length" v-for="item in detailData.hotelInfos"><span>{{item.cityName}}{{item.day}}</span>{{item.hotelName}}</div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.meals">
            <div class="info-item-title">
                餐饮
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.meals.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.scenicShow">
            <div class="info-item-title">
                景点演出
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.scenicShow.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.useCar">
            <div class="info-item-title">
                用车
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.useCar.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.visa">
            <div class="info-item-title">
                签证/通行证
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.visa.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.insurance">
            <div class="info-item-title">
                保险
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.insurance.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
        <div class="info-item" v-if="detailData.other">
            <div class="info-item-title">
                其他
            </div>
            <div class="info-item-cont">
                <div class="base-info-item" v-html="detailData.other.replace(/([\\\n\n\\\r\r]+)/g,'</br>')"></div>
            </div>
        </div>
    </section>
</template>

<script>
const { resizeImage } = require('@tuniu/light-helper');
export default {
    name: 'productDetail',
    props: {
        detailData: {
            type: Object,
            default: function () {
                return {}
            }
        },
    },
    data() {
        return {
            cIndex: 0,
            currentTraffic: this.detailData.trafficInfo && this.detailData.trafficInfo.length ? this.detailData.trafficInfo[0] : false,
            showIndex: 7,
            showAllFlag: true
        }
    },
    components: {
    },
    created: function () {
        if (this.detailData.trafficInfo && this.detailData.trafficInfo.length) {
            this.detailData.trafficInfo.forEach((item, index) => {
                if (item.departCityName === this.$store.state.departCityName) {
                    this.cIndex = index;
                    this.currentTraffic = this.detailData.trafficInfo[index]
                }
            })
        }
    },
    methods: {
        resizeImage: resizeImage,
        getBase64Url(str){

            let chartFlowName = '';
            switch (str) {
                case 'acceptService':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/37/43/Cii-tFuvNg-IT6WkAAAO6CaeJLIAAOcSgP_wf8AAA8A744.png'
                    break;
                case 'checkTicket':
                    chartFlowName = 'https://m1.tuniucdn.com/fb2/t1/G5/M00/37/43/Cii-s1uvNg-ISM41AAALNCeZan4AAOcSgP_0P8AAAtM112.png'
                    break;
                case 'confirm':
                    chartFlowName = 'https://m4.tuniucdn.com/fb2/t1/G5/M00/37/43/Cii-sluvNg-IDZvBAAAOGAfkrXcAAOcSgP_3EsAAA4w405.png'
                    break;
                case 'confirmReceipt':
                    chartFlowName = 'https://m4.tuniucdn.com/fb2/t1/G5/M00/37/43/Cii-s1uvNg-IcvX3AAAM6UczrA8AAOcSgP_6nsAAA0B384.png'
                    break;
                case 'delivery':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-sluvNg-II4ztAAALvP1oidYAAOcSwGgFN4AAAvU871.png'
                    break;
                case 'easeTour':
                    chartFlowName = 'https://m1.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-s1uvNg-Icf0PAAARidbOZpEAAOcSwGgILIAABGh700.png'
                    break;
                case 'happyTour':
                    chartFlowName = 'https://m4.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-tFuvNhCIdMEEAAARnq-dCZEAAOcSwGgMlMAABG2053.png'
                    break;
                case 'haveMeals':
                    chartFlowName = 'https://m4.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-s1uvNhCIG4YGAAAPXU844ZEAAOcSwGgRAkAAA91722.png'
                    break;
                case 'improveInfo':
                    chartFlowName = 'https://m3.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-tFuvNhCILbFYAAAPV-qFJ0oAAOcSwGgU34AAA9v512.png'
                    break;
                case 'noticeParking':
                    chartFlowName = 'https://m4.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-sluvNhCIVupIAAANua9iL9wAAOcSwG8q3wAAA3R999.png'
                    break;
                case 'parking':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-s1uvNhCIaqIyAAAQKvUKeLgAAOcSwG8uU0AABBC317.png'
                    break;
                case 'pay':
                    chartFlowName = 'https://m1.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-tFuvNhGIDjh3AAAK6NNRyRgAAOcSwG8yY8AAAsA151.png'
                    break;
                case 'sign':
                    chartFlowName = 'https://m2.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-s1uvNhGIE1BBAAAPRA0-ThAAAOcSwHcPp0AAA9c724.png'
                    break;
                case 'submit':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-s1uvNhGIIt-YAAALJq6M75EAAOcSwHk2e8AAAs-419.png'
                    break;
                case 'waitingReceipt':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/37/44/Cii-tFuvNhGIFNq_AAANzLa9JjgAAOcSwHtakYAAA3k875.png'
                    break;
                case 'deliveryPlan':
                    chartFlowName = 'https://m.tuniucdn.com/fb2/t1/G5/M00/F4/3D/Cii-tFwgbvOIGtB5AAAIEA80v5oAASEzwP_8XoAAAgo818.png'
                    break;
                case 'choose':
                    chartFlowName = 'https://m2.tuniucdn.com/fb2/t1/G7/M00/10/3B/Cii8KWXVhU2IEiQGAAAQqFplbzkAAMrBAP0s5UAABDA823.png'
                    break;
                case 'exchange':
                    chartFlowName = 'https://m2.tuniucdn.com/fb2/t1/G7/M00/10/3B/Cii8KmXVhU2IG9z6AAAMXEJZGugAAMrBAP0pyEAAAx0947.png'
                    break;
                default:
                    break;
            }
            return chartFlowName;
        },
        showTraffic (index) {
            this.cIndex = index;
            this.currentTraffic = this.detailData.trafficInfo[index];
            eventTrack('CLICK_INDEX_TRANSPORT');
        },
        showAll(length) {
            this.showIndex = length;
            this.showAllFlag = false;
        },
        hideAll() {
            this.showIndex = 7;
            this.showAllFlag = true;
        },
    }
}
</script>

<style lang="scss">
@import '../../style/common.scss';

.product-detail {
    .pic-item {
        position: relative;
        padding: 14px 0 10px;
        div {
            position: relative;
        }
    }
    .info-item {
        padding: 8px 0;
        background: #fff;
        &:nth-child(2) {
            margin-top: 0;
        }
        &-title {
            height: 24px;
            font-size: 20px;
            color: $fontStrongColor;
            margin-bottom: 8px;
        }
        &-cont {
            font-weight: 300;
            font-size: 15px;
            color: $fontStrongColor;
            line-height: 24px;
            img {
                max-width: 100%;
            }
            // img {
            //     position: absolute;
            //     top: 0;
            //     width: 100%;
            // }
        }
        &-images {
            margin: 10px 0;
            border-radius: $borderRadius;
            background:#efefef;
            overflow: hidden;
            img {
                display: block;
            }
            &.need-gap {
                border-radius: none;
                background: #fff;
                img {
                    border-radius: $borderRadius;
                    margin-bottom: 10px;
                    background:#efefef;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
    .traffic-depart-name {
        padding: 0 8px 8px;
        overflow: hidden;
        .item {
            display: inline-block;
            height: 26px;
            width: 70px;
            border: 1px solid #CCCCCC;
            border-radius: 2px;
            text-align: center;
            margin-right: 14px;
            margin-top: 14px;
            overflow: hidden;
            float: left;
            touch-action: manipulation;
        }
        .show-all, .show-no {
            margin-right: 0;
        }
        .noType {
            margin-right: 0;
        }
        .active {
            border: 1px solid #2DBB55;
            color: #2DBB55;
        }
    }
    .traffic-info {
        .traffic-info-item {
            padding-top: 10px;
            overflow: hidden;
            position: relative;
            .resource-col {
                height: 56px;
            }
            .tsp {
                position: absolute;
                top: 10px;
                left: 10px;
                width: 16px;
                span {
                    display: inline-block;
                    text-align: center;
                    line-height: 16px;
                    width: 16px;
                    height: 16px;
                    border: 1px solid #ddd;
                    box-sizing: border-box;
                    font-size: 10px;
                    color: #ddd;
                    margin-top: 10px;
                }
            }
            .depart {
                position: absolute;
                top: 10px;
                left: 50px;
                margin: 0 6px;
                &-time {
                    font-size: 16px;
                    color: #051B28;
                }
                &-name {
                    text-align: center;
                    font-size: 12px;
                    color: #999999;
                }
            }
            .middle {
                width: 140px;
                margin: 0 auto;
                text-align: center;
                .company-name {
                    font-size: 12px;
                    color: #666666;
                    position: relative;
                    &:before,&:after {
                        content: '';
                        position: absolute;
                        top: 52%;
                        background: rgba(221,221,221,0.50);
                        width: 30px;
                        height: 1px;
                    }
                    &:before {
                        left: 10px;
                    }
                    &:after {
                        right: 10px;
                    }
                }
                .company-num {
                    font-size: 12px;
                    color: #A5A5A5;
                    line-height: 10px;
                }
            }
            .arrive {
                position: absolute;
                top: 10px;
                right: 50px;
                margin-left: 20px;
                &-time {
                    font-size: 16px;
                    color: #051B28;
                }
                &-name {
                    text-align: center;
                    font-size: 12px;
                    color: #999999;
                }
            }
        }
    }
    .hotel-descr {
        color: #a5a5a5;
    }
    .hotel-list-item {
        color: #666;

        span{
            font-size: 14px;
            line-height: 25px;
            margin-right: 16px;
            color: #2A2A2A;
        }
    }
        .pic-item-inner{
            display: flex;
            justify-content: space-around;
            display: -webkit-flex; /* Safari */
            -webkit-justify-content: space-around; /* Safari 6.1+ */
            .pic-item-orderFlow{
                display:inline-block;
                position:relative;
                .pic-item-img{
                    display:block;
                    margin:0 auto;
                    width:39px;
                }
                span{
                    display:block;
                    text-align: center;
                    font-size:12px;
                    color:#777893;
                    transform: scale(0.8);
                }
            }
            .pic-item-split{
                display: flex;
                height: 1px;
                background: #fff;
                border-bottom: 1px dashed rgba(72,72,72,.2);
                justify-content: space-between;
                position: absolute;
                top: 20px;
                width: 100%;
                left: 80%;
            }
        }
}
</style>



// WEBPACK FOOTER //
// ProductDetail.vue